import { FC } from 'react';
import { WbCard, WbCardContent } from '@agilelab/plugin-wb-platform';
import { Editor } from '../common/Editor/Editor';

interface PolicyWittyGovernanceAgentEditorProps {
  onUpdate?: (code?: string) => void;
  editable?: boolean;
  policyContent: string;
  saving?: boolean;
  handleSave?: () => void;
  showSaveButton?: boolean;
}

export const PolicyWittyGovernanceAgentEditor: FC<
  PolicyWittyGovernanceAgentEditorProps
> = props => {
  return (
    <WbCard title="Policy Content">
      <WbCardContent>
        <Editor
          id="policy-content-editor"
          content={props.policyContent}
          theme={props.editable ? 'white' : 'default'}
          onUpdate={props.onUpdate}
          editable={props.editable}
          saving={props.saving}
          handleSave={props.handleSave}
          showSaveButton={props.showSaveButton}
          parser="go"
        />
      </WbCardContent>
    </WbCard>
  );
};
